





































import { Component } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  InputBookNumberTable,
  InputBookNumberTableItem
} from '@/components/organisms/InputBookNumberTable'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  CollectionRegistrationInfo,
  defaultDonor,
  defaultSimpleBibliographyReal,
  defaultTrader,
  Donor,
  ErrorMessage,
  SimpleBibliographyReal,
  Trader
} from '@/api'
import { SearchType } from '@/types'
import { BibliographyRealInfoMagazine } from '@/components/organisms/BibliographyRealInfoMagazine'
import {
  alertStore,
  donorStore,
  modalErrorStore,
  traderStore
} from '@/utils/store-accessor'

import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { RegistrationInfoEditTableItem } from '@/components/organisms/RegistrationInfoEditTable/RegistrationInfoEditTable.vue'
import dayjs from '@/node_modules/dayjs'
import { BibliographyRealInfoSimple } from '@/components/organisms/BibliographyRealInfoSimple'

interface ModalInputCollectionBookNumberInterface {
  bibliographyRealId: number
  onChecked: (array: RegistrationInfoEditTableItem[]) => void
}

@Component({
  components: {
    BibliographyRealInfoSimple,
    BibliographyRealInfoMagazine,
    InputBookNumberTable,
    ModalFooter
  }
})
export default class ModalInputCollectionBookNumber extends ModalComponentBaseVue {
  dialog: boolean = false

  bibliographyRealId: number = 0

  simpleBibliographyReal: SimpleBibliographyReal = defaultSimpleBibliographyReal()

  checkedCallback?: (array: RegistrationInfoEditTableItem[]) => void

  collectionRegistrationInfo: CollectionRegistrationInfo[] = []

  tableItems: InputBookNumberTableItem[] = []

  tableBodyHeight: number = 0

  get isMagazine(): boolean {
    return this.simpleBibliographyReal.searchType.code === SearchType.Magazine
  }

  calculateTableHeight() {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  open(params: ModalInputCollectionBookNumberInterface): void {
    this.dialog = true
    this.bibliographyRealId = params.bibliographyRealId
    this.checkedCallback = params.onChecked
    this.getSimpleBibliographyReal()
    this.getCollectionRegistrationInfo()
    this.$nextTick(() => {
      window.addEventListener('resize', this.calculateTableHeight)
      this.calculateTableHeight()
    })
  }

  close(): void {
    this.dialog = false
    this.bibliographyRealId = 0
    this.checkedCallback = undefined
    window.removeEventListener('resize', this.calculateTableHeight)
    this.collectionRegistrationInfo = []
  }

  createRegistrationInfoEditTableItem(): RegistrationInfoEditTableItem[] {
    const initialArray: RegistrationInfoEditTableItem[] = []
    this.tableItems
      .filter((value: InputBookNumberTableItem) => value.number.input !== '')
      .forEach(value => {
        if (Number(value.number.input) > 0) {
          for (let count = 0; count < Number(value.number.input); count++) {
            initialArray.push({
              id: {
                input: '',
                errorMessage: ''
              },
              holdingBranchCode: {
                input: value.branchCode.code,
                shortName: value.branchCode.shortName,
                errorMessage: ''
              },
              buyDepartmentCode: value.buyDepartmentCode.input,
              mark: '',
              ndc: '',
              book: '',
              sub: '',
              shelfType: {
                input: '',
                shortName: '',
                errorMessage: ''
              },
              collectionType: {
                input: value.collectionType.input,
                shortName: value.collectionType.shortName,
                errorMessage: ''
              },
              traderCode: {
                input: value.traderCode.input,
                shortName: value.traderCode.shortName,
                errorMessage: ''
              },
              donorCode: {
                input: value.donorCode.input,
                shortName: value.donorCode.shortName,
                errorMessage: ''
              },
              acceptOrderDate: {
                input: dayjs().format('YYYYMMDD'),
                errorMessage: ''
              },
              acceptOrderPrice: {
                input: String(value.acceptPrice),
                errorMessage: ''
              },
              acceptType: {
                input: value.acceptType.input,
                shortName: value.acceptType.shortName,
                errorMessage: ''
              },
              handlingType: {
                input: '',
                shortName: '',
                errorMessage: ''
              },
              appendixCode: {
                input: value.appendixCode.input,
                shortName: value.appendixCode.shortName,
                errorMessage: ''
              },
              equipType: value.equipType.input,
              budgetYear: Number(value.budgetYear.input),
              budgetBranchCode: value.budgetBranchCode.input,
              budgetDepartmentCode: value.budgetDepartmentCode.input,
              budgetExpenseCode: value.budgetExpenseCode.input,
              revision: 0
            })
          }
        }
      })
    return initialArray
  }

  print(): void {
    const element = document.getElementById(
      'modal-input-collection-book-number'
    )
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  setErrorMessage(alerts: Alert[]): void {
    alerts.some(alert => {
      if (alert.index === -1 || alert.subAttribute === '') return false

      const checkArray: InputBookNumberTableItem[] = this.tableItems.filter(
        value => value.number.input !== ''
      )
      const index: number = this.tableItems.findIndex(
        value =>
          value.branchCode.code === checkArray[alert.index].branchCode.code
      )

      if (index !== -1) {
        switch (alert.subAttribute) {
          case 'number':
            this.tableItems[index].number.errorMessage = alert.message
            break
          case 'trader_code':
            this.tableItems[index].traderCode.errorMessage = alert.message
            break
          case 'accept_type':
            this.tableItems[index].acceptType.errorMessage = alert.message
            break
          case 'buy_department_code':
            this.tableItems[index].buyDepartmentCode.errorMessage =
              alert.message
            break
          case 'donor_code':
            this.tableItems[index].donorCode.errorMessage = alert.message
            break
          case 'budget_year':
            this.tableItems[index].budgetYear.errorMessage = alert.message
            break
          case 'budget_branch_code':
            this.tableItems[index].budgetBranchCode.errorMessage = alert.message
            break
          case 'budget_department_code':
            this.tableItems[index].budgetDepartmentCode.errorMessage =
              alert.message
            break
          case 'budget_expense_code':
            this.tableItems[index].budgetExpenseCode.errorMessage =
              alert.message
            break
          case 'equip_type':
            this.tableItems[index].equipType.errorMessage = alert.message
            break
          case 'collection_type':
            this.tableItems[index].collectionType.errorMessage = alert.message
            break
          case 'appendix_code':
            this.tableItems[index].appendixCode.errorMessage = alert.message
            break
        }
      }
    })
  }

  async getSimpleBibliographyReal(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      this.simpleBibliographyReal = await bibliographyRealApi.getSimpleBibliographyReal(
        this.bibliographyRealId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async getCollectionRegistrationInfo(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      this.collectionRegistrationInfo = await bibliographyRealApi.getCollectionRegistrationInfo(
        this.bibliographyRealId
      )
      this.tableItems = this.collectionRegistrationInfo.map(value => {
        const trader: Trader =
          traderStore.findById(value.traderEnvVendorId) ?? defaultTrader()
        const donor: Donor =
          donorStore.findById(value.donorEnvVendorId) ?? defaultDonor()
        return {
          branchCode: value.branchCode,
          holdingCount: value.holdingCount,
          orderCount: value.orderCount,
          acceptPrice: value.acceptPrice,
          number: {
            input: '',
            errorMessage: ''
          },
          traderCode: {
            input: trader.code,
            shortName: trader.shortName,
            errorMessage: ''
          },
          acceptType: {
            input: value.acceptType.code,
            shortName: value.acceptType.shortName,
            errorMessage: ''
          },
          buyDepartmentCode: {
            input: value.buyDepartmentCode.code,
            shortName: value.buyDepartmentCode.shortName,
            errorMessage: ''
          },
          donorCode: {
            input: donor.code,
            shortName: donor.shortName,
            errorMessage: ''
          },
          budgetYear: {
            input: value.budgetYear,
            errorMessage: ''
          },
          budgetBranchCode: {
            input: value.budgetBranchCode.code,
            shortName: value.budgetBranchCode.shortName,
            errorMessage: ''
          },
          budgetDepartmentCode: {
            input: value.budgetDepartmentCode.code,
            shortName: value.budgetDepartmentCode.shortName,
            errorMessage: ''
          },
          budgetExpenseCode: {
            input: value.budgetExpenseCode.code,
            shortName: value.budgetExpenseCode.shortName,
            errorMessage: ''
          },
          equipType: {
            input: value.equipType.code,
            shortName: value.equipType.shortName,
            errorMessage: ''
          },
          collectionType: {
            input: value.collectionType.code,
            shortName: value.collectionType.shortName,
            errorMessage: ''
          },
          appendixCode: {
            input: '',
            shortName: '',
            errorMessage: ''
          }
        }
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
      this.close()
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async checkRegistrationInfo(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      // 登録冊数を入力した要素だけ送る
      await bibliographyRealApi.checkCollectionBookNumber({
        inputs: this.tableItems
          .filter(
            (value: InputBookNumberTableItem) => value.number.input !== ''
          )
          .map(item => {
            return {
              number: Number(item.number.input),
              traderCode: item.traderCode.input,
              donorCode: item.donorCode.input,
              acceptType: item.acceptType.input,
              buyDepartmentCode: item.buyDepartmentCode.input,
              budgetYear: Number(item.budgetYear.input),
              budgetBranchCode: item.budgetBranchCode.input,
              budgetDepartmentCode: item.budgetDepartmentCode.input,
              budgetExpenseCode: item.budgetExpenseCode.input,
              equipType: item.equipType.input,
              collectionType: item.collectionType.input,
              appendixCode: item.appendixCode.input
            }
          })
      })
      // 登録情報の編集ダイアログ初期値準備
      if (this.checkedCallback) {
        this.checkedCallback(this.createRegistrationInfoEditTableItem())
      }
      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
